import React from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { closeAdminDrawer } from "actions/drawers"
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft"
import {
  Divider,
  List,
  ListItem,
  ListItemText,
  Drawer,
  IconButton
} from "@material-ui/core/"
import { useSelector } from "react-redux"
import { useHistory } from "react-router-dom"

const AdminDrawer = ({ fullScreen, classes, dispatch, data, ...props }) => {
  const open = useSelector(state => state.drawers.adminDrawer)
  let history = useHistory()
  const handleClose = () => {
    dispatch(closeAdminDrawer())
  }

  function handleClick(route) {
    history.push(`/admin/${route}`)
    dispatch(closeAdminDrawer())
  }

  return (
    <Drawer
      className={classes.drawer}
      // variant="persistent"
      anchor="left"
      open={open}
      onClose={handleClose}
      classes={{
        paper: classes.drawerPaper
      }}
    >
      <div className={classes.drawerHeader}>
        <IconButton onClick={handleClose}>
          <ChevronLeftIcon />
        </IconButton>
      </div>
      <Divider />
      <List>
        {["Recent Posts", "Organizations", "Members", "Settings"].map(
          (text, index) => (
            <ListItem button key={text}>
              <ListItemText
                primary={text}
                onClick={() => handleClick(text.replace(" ", "").toLowerCase())}
              />
            </ListItem>
          )
        )}
      </List>
      <Divider />
    </Drawer>
  )
}

export default withStyles(styles)(AdminDrawer)



// WEBPACK FOOTER //
// ./src/components/AdminDrawer/index.jsx